/**
 * Whether a coach has any expandable "More Info" content (skills, accolades, or bio).
 * Accolades objects can be present but empty — only count fields with displayable values.
 */

export function hasCoachAccolades(coachAccolades) {
  return (
    coachAccolades?.yearsExperience > 0 ||
    coachAccolades?.numClientsSupported > 0 ||
    (coachAccolades?.numRatings > 0 && coachAccolades?.satisfactionRating > 0)
  )
}

export function hasCoachBio(coachBio) {
  return typeof coachBio === 'string'
    ? coachBio.trim().length > 0
    : Boolean(coachBio)
}

export function hasCoachAdditionalInfo(coach) {
  if (!coach) return false

  // New path: expand content comes from coach-info; show the control as soon as
  // we have a coachId (prefetch fills skills/accolades/bio).
  if (coach.coachId) return true

  return (
    coach.coachSkills?.length > 0 ||
    hasCoachAccolades(coach.coachAccolades) ||
    hasCoachBio(coach.coachBio)
  )
}
